import React from "react";
import { useDispatch, useSelector } from "src/store";
import { HoverRow } from "src/ui/shared/table/HoverRow";
import { MinimalTableCell } from "src/ui/shared/table/MinimalTableComponents";

import { selectGroupDetails, showDetails } from "@dashboard/devices/store";
import ElasticService from "@services/elasticService";
import { Cell, flexRender, Row } from "@tanstack/react-table";

import { GroupOverviewData } from "../GroupPage.utils";

const ignoredColumns = ["name", "action", "numberOfDevices"];

export const GroupTableRow = (props: Row<GroupOverviewData>) => {
    const dispatch = useDispatch();
    // Subscribe to just the selected boolean, not the whole details object: any details change
    // (selecting another row, the resetDetails fired on group create) would otherwise re-render
    // every row. Now only the rows whose selected state actually flips re-render.
    const isSelected = useSelector((state) => selectGroupDetails(state)?.selectedId === props.original.id);

    const onClick = (cell: Cell<GroupOverviewData, unknown>) => {
        ElasticService.createTransaction("tableElementClick", {
            table: "groups",
            click_element: cell.column.id === "description" ? "link" : "text",
        });

        if (cell.row.original.id && !ignoredColumns.includes(cell.column.id)) {
            dispatch(
                showDetails({
                    type: "group",
                    selectedId: cell.row.original.id,
                }),
            );
        }
    };

    return (
        <HoverRow {...props} selected={isSelected}>
            {props.getVisibleCells().map((cell) => {
                const cellContent = flexRender(cell.column.columnDef.cell, cell.getContext());
                return (
                    <MinimalTableCell
                        key={cell.id}
                        onClick={() => onClick(cell)}
                        fluid={cell.column.columnDef.meta?.fluid}
                        fluidMinWidth={cell.column.columnDef.meta?.fluidMinWidth}
                    >
                        {cellContent}
                    </MinimalTableCell>
                );
            })}
        </HoverRow>
    );
};
